/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiPersonCategory } from './InternalApiPersonCategory';
import {
    InternalApiPersonCategoryFromJSON,
    InternalApiPersonCategoryFromJSONTyped,
    InternalApiPersonCategoryToJSON,
    InternalApiPersonCategoryToJSONTyped,
} from './InternalApiPersonCategory';
import type { InternalApiSnoozeConfig } from './InternalApiSnoozeConfig';
import {
    InternalApiSnoozeConfigFromJSON,
    InternalApiSnoozeConfigFromJSONTyped,
    InternalApiSnoozeConfigToJSON,
    InternalApiSnoozeConfigToJSONTyped,
} from './InternalApiSnoozeConfig';
import type { InternalApiPersonType } from './InternalApiPersonType';
import {
    InternalApiPersonTypeFromJSON,
    InternalApiPersonTypeFromJSONTyped,
    InternalApiPersonTypeToJSON,
    InternalApiPersonTypeToJSONTyped,
} from './InternalApiPersonType';

/**
 * a Person
 * @export
 * @interface InternalApiPerson
 */
export interface InternalApiPerson {
    /**
     * External unique person ID
     * @type {string}
     * @memberof InternalApiPerson
     */
    id: string;
    /**
     * 
     * @type {InternalApiPersonType}
     * @memberof InternalApiPerson
     */
    type?: InternalApiPersonType;
    /**
     * Person attributes key value pair
     * @type {{ [key: string]: string; }}
     * @memberof InternalApiPerson
     */
    attributes?: { [key: string]: string; };
    /**
     * Person current status
     * @type {InternalApiPersonStatusEnum}
     * @memberof InternalApiPerson
     */
    status?: InternalApiPersonStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPerson
     */
    createdTime?: Date;
    /**
     * 
     * @type {InternalApiSnoozeConfig}
     * @memberof InternalApiPerson
     */
    snoozeConfiguration?: InternalApiSnoozeConfig;
    /**
     * Configurations for scenario based snooze configurations
     * @type {Array<InternalApiSnoozeConfig>}
     * @memberof InternalApiPerson
     */
    scenarioSnoozeConfigurations?: Array<InternalApiSnoozeConfig>;
    /**
     * 
     * @type {InternalApiPersonCategory}
     * @memberof InternalApiPerson
     */
    category?: InternalApiPersonCategory;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiPersonStatusEnum {
    NEW = 'NEW',
    REVIEWED = 'REVIEWED',
    MONITORING = 'MONITORING',
    SUSPENDED = 'SUSPENDED',
    TERMINATED = 'TERMINATED',
    TERMINATED_AND_REPORTED = 'TERMINATED_AND_REPORTED'
}


/**
 * Check if a given object implements the InternalApiPerson interface.
 */
export function instanceOfInternalApiPerson(value: object): value is InternalApiPerson {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InternalApiPersonFromJSON(json: any): InternalApiPerson {
    return InternalApiPersonFromJSONTyped(json, false);
}

export function InternalApiPersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPerson {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'] == null ? undefined : InternalApiPersonTypeFromJSON(json['type']),
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
        'status': json['status'] == null ? undefined : json['status'],
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
        'snoozeConfiguration': json['snoozeConfiguration'] == null ? undefined : InternalApiSnoozeConfigFromJSON(json['snoozeConfiguration']),
        'scenarioSnoozeConfigurations': json['scenarioSnoozeConfigurations'] == null ? undefined : ((json['scenarioSnoozeConfigurations'] as Array<any>).map(InternalApiSnoozeConfigFromJSON)),
        'category': json['category'] == null ? undefined : InternalApiPersonCategoryFromJSON(json['category']),
    };
}

export function InternalApiPersonToJSON(json: any): InternalApiPerson {
    return InternalApiPersonToJSONTyped(json, false);
}

export function InternalApiPersonToJSONTyped(value?: InternalApiPerson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': InternalApiPersonTypeToJSON(value['type']),
        'attributes': value['attributes'],
        'status': value['status'],
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
        'snoozeConfiguration': InternalApiSnoozeConfigToJSON(value['snoozeConfiguration']),
        'scenarioSnoozeConfigurations': value['scenarioSnoozeConfigurations'] == null ? undefined : ((value['scenarioSnoozeConfigurations'] as Array<any>).map(InternalApiSnoozeConfigToJSON)),
        'category': InternalApiPersonCategoryToJSON(value['category']),
    };
}

